var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "result-wrapper detail-page" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "pre-fill" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-xs-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.t("filter.loan_amount")))]),
              _vm._v(" "),
              _c("MoneyInput", {
                attrs: { value: _vm.amount },
                on: { change: _vm.amountChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-xs-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.t("filter.repayment_period")))]),
              _vm._v(" "),
              _c("IntegerInput", {
                ref: "tenor",
                attrs: {
                  label: _vm.t("filter.month_unit"),
                  value: _vm.tenor,
                  min: "6",
                },
                on: { change: _vm.monthChange },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "result-list result-list-wrapper popup-share" },
        [
          _c("div", { staticClass: "result-head" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.t("loan.orgranization")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-8" }, [
                _c("div", { staticClass: "row" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.t("loan.min_rate")))]),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "md", attrs: { width: "150" } },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.t("loan.total_amount")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "md", attrs: { width: "100" } },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.t("loan.tenor")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "sm", attrs: { width: "70" } },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.t("loan.tu")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "md", attrs: { width: "100" } },
                          [
                            _vm._v(
                              "\n                      " +
                                _vm._s(_vm.t("mortgage.payment_method")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("LoanCard", {
            attrs: { item: _vm.detail, "hide-detail-button": "" },
            on: { share: _vm.shareHandle },
          }),
          _vm._v(" "),
          _vm.showShare
            ? _c("Share", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.hideShare,
                    expression: "hideShare",
                  },
                ],
                attrs: { title: _vm.detail.shareMsg, id: _vm.detail.id },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "detail-content detailField" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.detail.detail) } }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }